/**
 * Get user profile actions
 */
export const getUserRequestAction = () => ({ type: 'getUserRequest' })
export const getUserSuccessAction = user => ({
  type: 'getUserSuccess',
  payload: user
})
export const getUserFailureAction = () => ({ type: 'getUserFailure' })

export const getGuestUserAction = () => ({
  type: 'getGuestUser'
})



// WEBPACK FOOTER //
// ./common/actions/user/profile.js